import { UserService } from '@/http-services/user.service';
import { AsyncFormControlValidator } from '../use-form-control';

export function UsernameOrEmailValidator(userService: UserService, username?: string): AsyncFormControlValidator {
  return async (val: string, signal) => {
    if (username === val || val === '') {
      return { valid: true, errors: [] };
    }
    const errors = await userService.validateUsernameOrEmail(val, true, signal);
    return { valid: errors.length ? false : true, errors };
  };
}
